import { getAmount, getColor } from './Common/Utils';
import { XGridChipCell } from '@AMIEWEB/Common';
import { XGridDefaultColumn } from '@AMIEWEB/Common/XGrid/cells/XGridDefaults';
import { formatDate } from '../helper';
import { XGridBonusIdCell } from './CustomComponents/XGridBonusIdCell';
import { GridCellParams, GridColumns } from '@mui/x-data-grid';
import { XGridBonusHistoryCell } from './CustomComponents/XGridBonusHistoryCell';
import i18next from 'i18next';

export const orderBonusGridColumns = (): GridColumns => [
  {
    ...XGridDefaultColumn,
    field: 'bonusType',
    headerName: i18next.t('order.orderBonusTab.grid.bonusType'),
    flex: 0,
    width: 140,
  },
  {
    ...XGridDefaultColumn,
    field: 'bonusAmount',
    headerName: i18next.t('order.orderBonusTab.grid.amount'),
    flex: 0,
    width: 120,
    renderCell: params => {
      return getAmount(params?.value);
    },
  },
  {
    ...XGridDefaultColumn,
    field: 'bonusStartDate',
    headerName: i18next.t('order.orderBonusTab.grid.startDate'),
    flex: 0,
    width: 130,
    renderCell: params => {
      return formatDate(params?.value);
    },
  },
  {
    ...XGridDefaultColumn,
    field: 'bonusEndDate',
    headerName: i18next.t('order.orderBonusTab.grid.endDate'),
    flex: 0,
    width: 120,
    renderCell: params => {
      return formatDate(params?.value);
    },
  },
  {
    ...XGridDefaultColumn,
    field: 'bonusPayer',
    headerName: i18next.t('order.orderBonusTab.grid.payer'),
    flex: 0,
    width: 110,
  },
  {
    ...XGridDefaultColumn,
    field: 'bonusStatus',
    headerName: i18next.t('order.orderBonusTab.grid.status'),
    flex: 0,
    width: 100,
    renderCell: XGridChipCell({
      size: 'small',
      dynamicColor: (params: GridCellParams) => {
        return getColor(params?.value);
      },
    }),
  },
  {
    ...XGridDefaultColumn,
    field: 'history',
    headerName: i18next.t('order.orderBonusTab.grid.history'),
    flex: 0,
    width: 70,
    sortable:false,
    renderCell: params => XGridBonusHistoryCell({ param: params }),
  },
  {
    ...XGridDefaultColumn,
    field: 'statusChangeDate',
    headerName: i18next.t('order.orderBonusTab.grid.statusChangeDate'),
    flex: 0,
    width: 170,
    renderCell: params => {
      return formatDate(params?.value, 'dateAnd12HourTime');
    },
  },
  {
    ...XGridDefaultColumn,
    field: 'statusChangedBy',
    headerName: i18next.t('order.orderBonusTab.grid.statusChangedBy'),
    flex: 0,
    width: 150,
  },
  {
    ...XGridDefaultColumn,
    field: 'bonusId',
    headerName: i18next.t('order.orderBonusTab.grid.bonusId'),
    flex: 0,
    width: 100,
    renderCell: params => XGridBonusIdCell({ gridCellParams: params, isPricingDesk: false }),
  },
  {
    ...XGridDefaultColumn,
    field: 'bonusBillAmount',
    headerName: i18next.t('order.orderBonusTab.grid.bonusBillAmount'),
    flex: 0,
    width: 130,
    renderCell: params => {
      return getAmount(params?.value);
    },
  },
];
